import getPageNavigationLinks from './pageNavigationLinks';

export default function useNavigationLinks(props) {
  const pageNavigationLinks = getPageNavigationLinks();

  return {
    pageLinks: pageNavigationLinks
  };
}
